<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red" style="height: 2rem;">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">开通记录</div> 
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      
      <!-- <div class="nav acea-row row-middle">
          <router-link :to="{ path: '/user/bill/0' }" class="item">
          <div>会员</div>
          <div class="num">{{huiyuan}}</div>
        </router-link>
        <div @click="goPagey('/user/bill/1')" class="item">
          <div>银卡</div>
          <div class="num">{{yinka}}</div>
        </div>
        <router-link :to="'/user/bill/2'" class="item">
          <div>白金卡</div>
          <div class="num">{{baijinka}}</div>
        </router-link>
        
      </div>  -->
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索会员名称" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2"></div>
      </div>
    </div>
    <div class="list">
      
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in spreadList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="val.avatar" /></div>
            <div class="text">
              <div class="name line1">{{ val.nickname }}({{ val.real_name }})</div>
              <div>加入时间: {{ val.time }}</div>
            </div>
          </div>
          <div class="right">
            <div>
             下级 <span class="font-color-red">{{ val.childCount }}</span> 人
            </div>
            
            <!-- <div>订单 {{ val.orderCount }} 单</div> -->
            <!-- <div>{{ val.numberCount ? val.numberCount : 0 }} 元</div> -->
            <div @click="delBd(index)" style="margin-top: 0.3rem;">
               <span class="iconfont icon-shanchu"></span>删除
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getBdUser,getBdRemove } from "../../api/user";
import Loading from "@components/Loading";
const NAME = "BdUser";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        keyword: "",
        sort: ""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: "",
      tuidui:"",
      zhitui:"",
      huiyuan:"",
      yinka:"",
      baijinka:""
    };
  },
  mounted: function() {
    this.getBdUser();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getBdUser();
    });
  }, 
  watch: {
	$route(n) {
	    if (n.name === NAME){
			this.screen.page = 0;
			this.loaded = false;
			this.loading = false;
			this.spreadList = [];
			this.getBdUser();
		}
	},
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getBdUser();
    }
  },
  methods: {
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getBdUser();
    },
     /**
     * 删除报单用户
     */
     delBd: function(index) {
      let that = this; 
      let address = this.spreadList[index];
      //console.log(index);
     // console.log(address);
      let id = address.uid;
      getBdRemove(id).then(function() {
        that.$dialog.toast({
          mes: "删除成功!",
          callback: () => {
            that.spreadList.splice(index, 1);
            that.$set(that, "spreadList", that.spreadList);
         
          }
        });
      }).catch(function(error) {
        // 在这里处理错误，例如显示错误提示
        console.log(error);
        that.$dialog.toast({
        mes: error.msg,
        // 可以根据需要添加其他错误处理逻辑
        });
    });
    },
    getBdUser: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getBdUser(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data.list);
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
          that.first = res.data.total;
          that.second = res.data.totalLevel;
          that.tuidui = res.data.total;
          that.zhitui = res.data.zhitui;
          that.yinka = res.data.yinka;
          that.baijnika = res.data.baijin;
          that.huiyuan = res.data.huiyuan;
          that.yinka = res.data.yinka;
          that.baijinka = res.data.baijin;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        this.screen.grade = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "childCount":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "";
          }
          break;
        case "numberCount":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        case "orderCount":
          if (that.orderCount == 2) {
            that.orderCount = 1;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount DESC";
          } else if (that.orderCount == 1) {
            that.orderCount = 3;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount ASC";
          } else if (that.orderCount == 3) {
            that.orderCount = 2;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    }
  }
};
</script>
<style>
.header  .nav{background-color:#fff;border-radius:0.06rem;height:1.4rem; line-height:.6rem; width: 6.92rem; margin: 0 auto; padding-top: .1rem; margin-bottom: 10px;}
.header  .nav .item{flex:1;-webkit-flex:1;-o-flex:1;-ms-flex:1;text-align:center;font-size:0.3rem;position:relative;}
.header  .nav .item~.item:after{position:absolute;content:'';left:0;width:1px;height:0.7rem;background-color:#eee;
top:50%;margin-top:-0.35rem;}
.header  .nav .item .num{font-size:0.36rem;color:#282828; line-height: .6rem;}
</style>